import { Palette, Code2, TrendingUp, Megaphone } from "lucide-react";

export const BRAND = {
  name: "STUZIO. EDITFLOW",
  tagline: "Smarter Marketing. Better Results.",
  founder: "Ritesh Maurya",
  email: "editflowstuzio@gmail.com",
  phoneDisplay: "+91 83030 33434",
  location: "Varanasi, India — serving clients across India",
};

export const waLink = (msg) =>
  `https://wa.me/918303033434?text=${encodeURIComponent(msg)}`;

export const WA_DEFAULT = waLink(
  "Hi Ritesh! I found STUZIO. EDITFLOW online and I'd like to discuss a website project for my business."
);
export const WA_DEMO = waLink(
  "Hi Ritesh! I want my FREE custom demo website built with my business info. Here's what my business does: "
);

export const TRUST_LINES = [
  "No advance until you approve the demo",
  "7-day delivery",
];

export const projects = [
  {
    title: "Aetheria — Luxury E-Commerce",
    category: "E-Commerce · Web Design",
    img: "https://images.unsplash.com/photo-1658216768198-92d71d6a72c9?w=1200&q=80&auto=format&fit=crop",
    alt: "Dark editorial e-commerce website design for a luxury brand, designed by STUZIO. EDITFLOW",
    result: "+212% online sales in 90 days",
  },
  {
    title: "Vortex AI — SaaS Platform",
    category: "Fullstack Web App",
    img: "https://images.pexels.com/photos/8408538/pexels-photo-8408538.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "SaaS dashboard web application UI built by a professional web developer in India",
    result: "4.9★ user rating post-launch",
  },
  {
    title: "Solstice — Editorial Magazine",
    category: "Brand · UI/UX System",
    img: "https://images.pexels.com/photos/35995685/pexels-photo-35995685.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Editorial magazine website with custom brand system and typography",
    result: "3.1× longer read sessions",
  },
  {
    title: "Kaveri Handlooms — D2C Store",
    category: "E-Commerce · Branding",
    img: "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=1200&q=80&auto=format&fit=crop",
    alt: "Custom website design for an Indian handloom D2C business with online store",
    result: "First sale within 48 hours of launch",
  },
];

export const services = [
  {
    icon: Palette,
    num: "01",
    title: "Web Design",
    desc: "Editorial, conversion-first design that makes your business look like the obvious choice.",
  },
  {
    icon: Code2,
    num: "02",
    title: "Development",
    desc: "Hand-coded, lightning-fast websites. No bloated templates, no page builders.",
  },
  {
    icon: TrendingUp,
    num: "03",
    title: "SEO",
    desc: "Rank on Google for the searches your customers actually make — local and national.",
  },
  {
    icon: Megaphone,
    num: "04",
    title: "Branding & Marketing",
    desc: "Identity, messaging and funnels engineered to turn visitors into paying customers.",
  },
];

export const processSteps = [
  {
    num: "01",
    title: "Discovery Call",
    desc: "A free 15-minute chat about your business, your customers and what your website must achieve.",
  },
  {
    num: "02",
    title: "Free Custom Demo",
    desc: "We build a real demo homepage with YOUR business name, content and branding — before you pay anything.",
  },
  {
    num: "03",
    title: "Unlimited Revisions",
    desc: "We refine the demo together until you genuinely love it. No clock, no pressure, no advance taken.",
  },
  {
    num: "04",
    title: "40% Advance to Build",
    desc: "Only after you approve the demo, a 40% advance kicks off the full build.",
  },
  {
    num: "05",
    title: "Launch & Balance",
    desc: "Your site goes live. You pay the remaining balance on launch day — and get full ownership.",
  },
];

export const stats = [
  { value: 40, suffix: "+", label: "Projects Delivered" },
  { value: 7, suffix: "", label: "Days Avg. Delivery" },
  { value: 100, suffix: "%", label: "Client Satisfaction" },
];

export const paymentTerms = [
  { step: "Free demo first", desc: "A custom homepage built with your real business info. Zero cost, zero obligation." },
  { step: "Unlimited revisions", desc: "We iterate together until every pixel feels right to you." },
  { step: "You approve", desc: "Nothing moves forward — and no money changes hands — until you say yes." },
  { step: "40% advance", desc: "Only after approval. This starts the full build." },
  { step: "Launch", desc: "Your site goes live, typically within 7 days of approval." },
  { step: "Pay the balance", desc: "The remaining 60% is due on launch day. Then it's 100% yours." },
];

export const testimonials = [
  {
    name: "Ankit Verma",
    role: "Founder, Verma Textiles · Varanasi",
    quote: "I paid nothing until I saw my own demo. The site Ritesh built brings me wholesale enquiries every single week — my only regret is not doing it two years earlier.",
  },
  {
    name: "Dr. Neha Singh",
    role: "Dental Clinic Owner · Lucknow",
    quote: "Appointment calls doubled within a month of launch. He explained everything in plain language and delivered in 6 days, exactly as promised.",
  },
  {
    name: "Rahul Khanna",
    role: "Director, Kashi Heritage Tours",
    quote: "The free demo sold me instantly. Foreign tourists now find us on Google and book directly — no middlemen, no commissions.",
  },
  {
    name: "Priya Malhotra",
    role: "Boutique Owner · Delhi",
    quote: "Premium look, honest pricing, and unlimited patience with my revisions. My Instagram followers constantly ask who made the website.",
  },
];

export const faqs = [
  {
    q: "How much does a website cost?",
    a: "It depends on pages and features, but everything starts free: you get a custom demo built with your real business info before paying anything. Once you approve it, a transparent fixed quote is locked in — 40% advance to build, balance on launch. Most small-business sites fall in a very affordable range, and you'll know the exact number upfront after our discovery call.",
  },
  {
    q: "How long will my website take?",
    a: "Most websites are delivered in 7 days after you approve the demo. Larger e-commerce or custom web-app projects get a clear day-by-day timeline before we start — and we stick to it.",
  },
  {
    q: "What technology do you use?",
    a: "Modern, hand-coded stacks — React on the frontend, fast secure backends, and performance-first builds that load in under 2 seconds on budget phones. No bloated page builders. If your project genuinely fits WordPress or Shopify better, we'll tell you honestly.",
  },
  {
    q: "What if I don't like the design?",
    a: "Then you pay nothing. The demo phase includes unlimited revisions — we keep refining until you approve. The 40% advance is only taken after your explicit yes, so the risk stays entirely on my side.",
  },
  {
    q: "Do I own the website after launch?",
    a: "100%. Domain, hosting accounts, source code, content and every credential are handed over to you on launch day with a simple handover document. No lock-in, no hostage situations, ever.",
  },
  {
    q: "What happens after the site goes live?",
    a: "Every project includes 30 days of free post-launch support — fixes, tweaks and guidance. After that, optional monthly maintenance plans cover updates, backups, SEO monitoring and small changes.",
  },
];

export const workShowcase = [
  {
    name: "Yuvraj Traders",
    category: "Retail & Trading · Varanasi",
    img: "/assets/work/yuvraj-traders.webp",
    alt: "Mobile website designed by STUZIO. EDITFLOW for Yuvraj Traders, a retail and trading business in Varanasi",
    tagline: "A neighbourhood trader, now a brand customers ask for by name.",
  },
  {
    name: "Team Blr",
    category: "Real Estate Advisory · Bengaluru",
    img: "/assets/work/team-blr.webp",
    alt: "Premium real estate advisory website for Team Blr Bengaluru, designed and developed by STUZIO. EDITFLOW",
    tagline: "Quiet-luxury property advisory, built for high-intent buyers.",
  },
  {
    name: "Unicare Health Clinic",
    category: "Aesthetics & Wellness Clinic",
    img: "/assets/work/unicare.webp",
    alt: "Clinic website with appointment booking built by STUZIO. EDITFLOW for Unicare Health Clinic",
    tagline: "One-tap booking and WhatsApp, straight from the homepage.",
  },
  {
    name: "Toronto Associates",
    category: "Property Advisory · Toronto",
    img: "/assets/work/toronto-associates.webp",
    alt: "Personal property advisor website designed by STUZIO. EDITFLOW for Toronto Associates, Canada",
    tagline: "A personal advisory brand that feels like calm.",
  },
  {
    name: "Pulse Care Hospital",
    category: "Multi-speciality Hospital · India",
    img: "/assets/work/pulse-care.webp",
    alt: "Hospital website with call, WhatsApp and booking actions built by STUZIO. EDITFLOW for Pulse Care Hospital",
    tagline: "Call, WhatsApp or book — care is one tap away.",
  },
];

export const teamRoles = [
  {
    name: "Ritesh Maurya",
    role: "Founder & Lead Developer",
    desc: "Design, code, SEO and strategy — Ritesh leads every project personally from demo to launch.",
    img: "/assets/founder.jpg",
    alt: "Ritesh Maurya, Founder and Lead Developer of STUZIO. EDITFLOW, professional web developer in India",
    founder: true,
  },
  {
    name: "Design Collaborator",
    role: "UI / Brand Design",
    desc: "Specialist designers from our collaborator network join when a project needs extra visual firepower.",
    img: null,
  },
  {
    name: "Growth Strategist",
    role: "SEO & Marketing",
    desc: "Keyword research, local SEO and launch marketing for clients who want traffic, not just a pretty site.",
    img: null,
  },
  {
    name: "QA & Support",
    role: "Testing & Care",
    desc: "Every build is tested on real devices and slow networks before you ever see it.",
    img: null,
  },
];

export const navLinks = [
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];
